/**
 * IANA timezone helpers for the automation builder.
 *
 * Uses the ICU data the browser already ships rather than adding a date
 * library — this codebase has zero date dependencies and the server validates
 * the same way. Only real zone names are offered: a fixed offset like "UTC-5"
 * would not survive DST, silently shifting every send by an hour in November.
 */

/** A small fallback for browsers without `Intl.supportedValuesOf`. */
const FALLBACK_ZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'UTC',
];

export function timezoneOptions(): string[] {
  const supported = (
    Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }
  ).supportedValuesOf;
  if (typeof supported !== 'function') return FALLBACK_ZONES;
  try {
    return supported('timeZone');
  } catch {
    return FALLBACK_ZONES;
  }
}

/** The admin's own zone, as a sensible default for a new automation. */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Chicago';
  } catch {
    return 'America/Chicago';
  }
}
